export * from './FocusTrapZone';
//# sourceMappingURL=index.js.map